import { Skeleton, styled } from '@mui/material';

export const ProgressSkeleton = styled(Skeleton)(() => ({
  borderRadius: '5px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.MuiSkeleton-root>*': {
    visibility: 'initial',
  },
}));
